import { createSelector } from 'reselect'

import { getCurrentAccount } from 'state/selectors'

export const processStatuses = createSelector(
	[
		state => state.account.entities.statuses,
		state => getCurrentAccount(state),
		(state, props) => props.column,
	],
	(allStatuses, account, column) => {
		const statuses = []

		if (!account || !account.statuses) {
			return statuses
		}

		account.statuses.forEach(statusId => {
			const defaultStatus = allStatuses[statusId]

			const customStatus = (column && column.data) ? column.data.find(columnStatus => {
				return columnStatus.status_id === statusId
			}) : null

			const item = {
				...defaultStatus,
				status_id: statusId,
			}

			if(customStatus){
				item.custom_name = customStatus.custom_name
				item.order = customStatus.order
			}

			statuses.push(item)
		})

		statuses.sort((a, b) => {
			return a.order - b.order
		})

		return statuses
	}
)

export const getTaskUploads = createSelector(
	[
		state => state.account.entities.tasks,
		state => state.account.entities.files,
		state => state.account.entities.versions,
		state => state.account.currentTaskId
	],
	(tasks, files, versions, taskId) => {
		const types = ['files','versions']
		const returnObject = {
			files: [],
			versions: []
		}

		if(!taskId){
			return returnObject
		}

		const task = tasks ? tasks[taskId] : null

		types.forEach(type => {
			if(!task || !task[type]){
				return 
			}

			let uploadIds = task[type]
			let taskUploads = []
	
			uploadIds.forEach(uploadId => {
				const entitiesObject = type == 'files' ? files : versions
				const upload = entitiesObject[uploadId]
	
				if(!upload){
					return
				}
	
				upload.type = type
	
				if(upload){
					taskUploads.push(upload)
				}
			})

			returnObject[type] = taskUploads
		})

		return returnObject
	}
)